import React from 'react'
import { Routes, Route } from "react-router-dom";
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';
import CookiesNotification from './components/CookiesNotification';

//Pages
import {
  Home, NotFound, CryptocurrenciesList, AssetPage,
  Login, Signup, Portfolio, CashTransactions, News, AddFunds,
  Profile, BankDetails, Merch, Sell, Buy, ForgotPassword, WithdrawFunds,
  ThankYou, DetailedChart, Overview
} from './pages';

function App() {

  return (
    <>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/CryptocurrenciesList" element={<CryptocurrenciesList />} />
        <Route path="/AssetPage/:id" element={<AssetPage />} />
        <Route path="/Login" element={<Login />} />
        <Route path="/Signup" element={<Signup />} />
        <Route path="/Portfolio" element={<Portfolio />} />
        <Route path="/CashTransactions" element={<CashTransactions />} />
        <Route path="/News" element={<News />} />
        <Route path="/AddFunds" element={<AddFunds />} />
        <Route path="/Profile" element={<Profile />} />
        <Route path="/BankDetails/:id" element={<BankDetails />} />
        <Route path="/Merch" element={<Merch />} />
        <Route path="/Sell/:id" element={<Sell />} />
        <Route path="/Buy/:id" element={<Buy />} />
        <Route path="/ForgotPassword" element={<ForgotPassword />} />
        <Route path="/WithdrawFunds" element={<WithdrawFunds />} />
        <Route path="/ThankYou" element={<ThankYou />} />
        <Route path="/Chart/:id" element={<DetailedChart />} />
        <Route path="/Overview" element={<Overview />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <CookiesNotification />
      <Footer />
    </>
  );
}

export default App;
